module.exports = __webpack_public_path__ + "img/17_80.f314fc6a.png";